import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import MultiplexAds from "../../Admin/Pages/MultiplexAds";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
import WorkspaceDescription from "./WorkspaceDescription";
export default function HouseRentDetails() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("roomInfo");

  const [showZoom, setShowZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({
    x: 50,
    y: 50,
  });

  const imageContainerRef = useRef(null);

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    setUser(loginUser);

    if (loginUser) {
      const savedWishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

      setWishlist(savedWishlist);
    }
  }, []);

  useEffect(() => {
    const syncWishlist = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));

      if (loginUser) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

        setWishlist(saved);
        setUser(loginUser);
      }
    };

    window.addEventListener("cartUpdated", syncWishlist);
    window.addEventListener("storage", syncWishlist);

    return () => {
      window.removeEventListener("cartUpdated", syncWishlist);
      window.removeEventListener("storage", syncWishlist);
    };
  }, []);

  useEffect(() => {
    fetch(`${API.LIST_ACTIVE_WORKSPACES}`)
      .then((res) => res.json())
      .then((result) => {
        const selected = result.find((item) => String(item.id) === String(id));

        setData(selected);
      })
      .catch((error) => {
        console.error("Room fetch error:", error);
      });
  }, [id]);

  const images = data?.image
    ? data.image
        .split(",")
        .map((img) => img.trim())
        .filter(Boolean)
    : [];

  const currentImage =
    images.length > 0
      ? `${UPLOADS.WORKSPACE_IMAGE}${images[currentIndex]}`
      : "/img/no-image.png";

  const handleZoomMove = (e) => {
    const container = imageContainerRef.current;

    if (!container) return;

    const rect = container.getBoundingClientRect();

    let x = ((e.clientX - rect.left) / rect.width) * 100;
    let y = ((e.clientY - rect.top) / rect.height) * 100;

    // Keep values inside image
    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));

    setZoomPosition({
      x,
      y,
    });
  };

  const changeImage = (index) => {
    setCurrentIndex(index);

    // Reset zoom position
    setZoomPosition({
      x: 50,
      y: 50,
    });

    setShowZoom(false);
  };

  // ============================
  // WISHLIST TOGGLE
  // ============================
  const toggleLike = () => {
    if (!user) {
      alert("Please login first");
      return;
    }

    let updatedWishlist = [...wishlist];

    const exists = updatedWishlist.find((item) => item.id === data.id);

    if (exists) {
      updatedWishlist = updatedWishlist.filter((item) => item.id !== data.id);
    } else {
      updatedWishlist.push({
        ...data,
        type: "workspace",
      });
    }

    setWishlist(updatedWishlist);

    localStorage.setItem(
      `wishlist_${user.id}`,
      JSON.stringify(updatedWishlist),
    );

    window.dispatchEvent(new Event("cartUpdated"));
  };

  // ============================
  // LOADING
  // ============================
  if (!data) {
    return (
      <div className="container text-center mt-5">
        <h4>No Room Data Found</h4>

        <button className="btn btn-primary" onClick={() => navigate("/house")}>
          Back to Listings
        </button>
      </div>
    );
  }

  return (
    <div className="container-fluid product-page">
      <div className="row">
        {/* ============================
            BACK BUTTON
        ============================ */}
        <div className="mb-3" data-aos="fade-right">
          <button
            className="btn btn-light back-btn"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-arrow-left"></i> Back
          </button>
        </div>

        {/* ============================
            LEFT IMAGE + ZOOM
        ============================ */}
        <div className="col-md-6" data-aos="fade-right">
          <div className="workspace-image-area">
            {/* MAIN IMAGE */}
            <div className="product-image-section zoom-image-wrapper">
              <div
                ref={imageContainerRef}
                className="zoom-source-image"
                onMouseEnter={() => setShowZoom(true)}
                onMouseMove={handleZoomMove}
                onMouseLeave={() => setShowZoom(false)}
              >
                <img
                  src={currentImage}
                  className="product-main-img"
                  alt="Workspace"
                  draggable="false"
                />

                {/* Mouse Lens Indicator */}
                {showZoom && (
                  <div
                    className="zoom-hover-indicator"
                    style={{
                      left: `${zoomPosition.x}%`,
                      top: `${zoomPosition.y}%`,
                    }}
                  />
                )}
              </div>

              {/* ============================
                  ZOOM PANEL
              ============================ */}
              {showZoom && (
                <div
                  className="zoom-preview"
                  style={{
                    backgroundImage: `url("${currentImage}")`,
                    backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                  }}
                />
              )}

              {/* ============================
                  THUMBNAILS
              ============================ */}
              {images.length > 1 && (
                <div className="thumbnail-wrapper mt-3">
                  {images.map((img, index) => (
                    <img
                      key={index}
                      src={`${UPLOADS.WORKSPACE_IMAGE}${img}`}
                      onClick={() => changeImage(index)}
                      className={`thumbnail-img ${
                        currentIndex === index ? "active-thumb" : ""
                      }`}
                      alt={`Workspace ${index + 1}`}
                      draggable="false"
                      onError={(e) => {
                        e.target.src = "/img/no-image.png";
                      }}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ============================
            CENTER / RIGHT INFO
        ============================ */}
        <div className="col-lg-6">
          <div className="product-card1 mt-4" data-aos="fade-up">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h2 className="product-title">{data.city} Workspace</h2>

                <h3 className="product-price">
                  ₹{Number(data.rent_price).toLocaleString("en-IN")}
                  <small
                    style={{
                      fontSize: "14px",
                      color: "#666",
                    }}
                  >
                    / month
                  </small>
                </h3>
              </div>

              <button className="like-btn" onClick={toggleLike}>
                <i
                  className={
                    wishlist.some((w) => w.id === data.id)
                      ? "bi bi-heart-fill text-danger"
                      : "bi bi-heart"
                  }
                ></i>
              </button>
            </div>

            <p className="mt-3">
              <strong>Size:</strong> {data.size}
            </p>

            <p className="product-desc">{data.description}</p>

            <a
              href={`https://wa.me/91${data.phone}`}
              target="_blank"
              rel="noreferrer"
              className="btn btn-success w-100 mt-3 py-2"
            >
              <i className="bi bi-whatsapp me-2"></i>
              Contact Owner
            </a>
          </div>

          {/* ============================
              TABS
          ============================ */}
          <div className="mt-4" data-aos="fade-left">
            <ul className="nav nav-tabs custom-tabs mb-2">
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "roomInfo" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("roomInfo")}
                >
                  Room Specs
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "ownerInfo" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("ownerInfo")}
                >
                  Owner Info
                </button>
              </li>
            </ul>

            <div className="tab-content">
              {/* ROOM INFO */}
              <div
                className={`tab-pane fade ${
                  activeTab === "roomInfo" ? "show active" : ""
                }`}
              >
                <table className="info-table">
                  <tbody>
                    <tr>
                      <th>Size In Feet</th>
                      <td>{data.size}</td>
                    </tr>

                    <tr>
                      <th>Floor</th>
                      <td>{data.floor}</td>
                    </tr>

                    <tr>
                      <th>Address</th>
                      <td>{data.address}</td>
                    </tr>

                    <tr>
                      <th>Landmark</th>
                      <td>{data.location}</td>
                    </tr>

                    <tr>
                      <th>City</th>
                      <td>{data.city}</td>
                    </tr>

                    <tr>
                      <th>State</th>
                      <td>{data.state}</td>
                    </tr>

                    <tr>
                      <th>Rent</th>
                      <td>
                        ₹{Number(data.rent_price).toLocaleString("en-IN")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* OWNER INFO */}
              <div
                className={`tab-pane fade ${
                  activeTab === "ownerInfo" ? "show active" : ""
                }`}
              >
                <table className="info-table">
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <td>{data.owner_name}</td>
                    </tr>

                    <tr>
                      <th>Address</th>
                      <td>{data.address}</td>
                    </tr>

                    <tr>
                      <th>Landmark</th>
                      <td>{data.location}</td>
                    </tr>

                    <tr>
                      <th>Phone</th>
                      <td>{data.phone}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* ADS */}
        {/* DYNAMIC RENTAL DESCRIPTION */}
        <div className="col-12">
          <WorkspaceDescription data={data} />
        </div>

        {/* ADS */}
        <HorizontalAds />
      </div>
    </div>
  );
}
